import { get } from 'lodash/fp';
import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken, Stack } from '@optimus-web/core';
import {
    getFlexDirection,
    getHeightInPxOr100Percent,
    getHeightInPxOrAuto,
    getWidthInPxOr100Percent,
    getWidthInPxOrAuto,
} from './utils';

export const MatrixWrapperElement = styled.div`
    background-color: ${getToken('backgroundStaticFlat')};
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    height: ${getHeightInPxOr100Percent};
    width: ${getWidthInPxOr100Percent};
    ${(props) => (props as $TSFixMe).disableScrollSync && `overflow: scroll;`}
`;

export const CornerCellElement = styled.div`
    box-sizing: border-box;
    height: ${getHeightInPxOrAuto};
`;

export const MatrixAsideWrapperElement = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 0 0 ${getWidthInPxOrAuto};
    height: ${getHeightInPxOrAuto};
    overflow: hidden;
`;

export const MatrixBodyWrapperElement = styled.div`
    display: flex;
    flex-direction: ${getFlexDirection};
    ${(props) => !(props as $TSFixMe).disableScrollSync && `overflow: auto;`}
`;

export const MatrixContentWrapperElement = styled.div`
    display: flex;
    flex-direction: column;
    ${(props) => !(props as $TSFixMe).disableScrollSync && `min-width: 0;`}
`;

export const MatrixHeaderWrapperElement = styled.div`
    box-sizing: border-box;
    display: flex;
    flex: 0 0 ${getHeightInPxOrAuto};
    flex-direction: row;
    overflow: hidden;
    max-width: ${getWidthInPxOr100Percent};
`;

export const MatrixVectorWrapperElement = styled.div`
    display: flex;
    flex-direction: ${get('vectorDirection.value')};
    flex-grow: 1;
    flex-shrink: 0;
    width: min-content;
`;

export const MatrixCellWrapperElement = styled(Stack)`
    box-sizing: border-box;
    flex-shrink: 0;
    height: ${getHeightInPxOrAuto};
    width: ${getWidthInPxOrAuto};
`;

export const MatrixHeaderCellElement = styled(MatrixCellWrapperElement)`
    ${getTextTokenPreset('bodySmallStrong')};
    padding: ${getSpacingToken('200')}px;
    position: relative;
`;
